import React from 'react'

import { applyStyle, formatResponsiveProps, getSmartSize } from '../helpers/styles'
import { useMarginStyle } from './margin'
import { usePaddingStyle } from './padding'
import { useSizeStyle } from './size'

export const useGridStyle = initialProps => {
  const { gutter, paddingGutter, flex, direction, justify, align, wrap, gap, ...props } =
    formatResponsiveProps(initialProps)
  const marginStyle = useMarginStyle(props)
  const paddingStyle = usePaddingStyle(props)
  const sizeStyle = useSizeStyle(props)
  const margin = gutter || paddingGutter

  return React.useMemo(
    () => `
      display: flex;
      flex-direction: ${direction || 'column'};
      ${applyStyle('margin', margin, `-${getSmartSize(margin)}`)}
      ${applyStyle('margin-bottom', paddingGutter, `${getSmartSize(margin)}`)}
      ${applyStyle('flex', flex)}
      ${applyStyle('justify-content', justify)}
      ${applyStyle('gap', gap, getSmartSize(gap))}
      ${applyStyle('align-items', align)}
      ${applyStyle('flex-wrap', wrap, 'wrap')}
      ${marginStyle}
      ${paddingStyle}
      ${sizeStyle}

      & > * {
        ${applyStyle('margin', gutter, getSmartSize(gutter))}
        ${applyStyle('padding', paddingGutter, getSmartSize(paddingGutter))}
      }
    `,
    [
      gutter, //
      flex,
      direction,
      justify,
      align,
      marginStyle,
      paddingStyle,
      sizeStyle,
      wrap,
      paddingGutter,
      margin,
      gap
    ]
  )
}
